import React from 'react'
import { Control, Controller, useController, UseControllerProps } from 'react-hook-form';
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel';
import InputLabel from '@mui/material/InputLabel'
import { SelectProps } from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormHelperText from '@mui/material/FormHelperText'
import { Checkbox, InputProps, SxProps, TextFieldProps, CheckboxProps } from '@mui/material';


export interface ICheckBoxInputProps extends Omit<UseControllerProps, 'control'> {
    id?: string,
    negativeValue?:boolean,
    name: string,
    control: Control<any, object>,
    label?: React.ReactElement | string,
    placeholder?: string,
    inputProps?: InputProps['inputProps'],
    size?: 'small' | 'medium',
    sx?: SxProps,
    asNumber?: boolean,
    fullWidth?: boolean,
    onChange?(event: React.ChangeEvent<HTMLInputElement>): any,
    onBlur?(event: React.FocusEvent<any>): any,
    //rest
    className?: string,
}

export default function CheckBoxInput({ id, name, negativeValue, placeholder, size = "small", fullWidth = true, onChange = () => { }, onBlur = () => { }, control, inputProps, label, asNumber, ...rest }: ICheckBoxInputProps & CheckboxProps) {

    const { field, fieldState } = useController({ control, name })

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let checkedValue = negativeValue ? !event.target.checked : event.target.checked
        let valueToSet = field.value instanceof Boolean ? checkedValue : +checkedValue
        field.onChange(valueToSet)
        onChange(event)
    }

    const handleOnBlur = (event: React.FocusEvent<HTMLButtonElement, Element>) => {
        field.onBlur();
        onBlur(event);
    }

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { name, value, ref, onChange, onBlur }, fieldState: { error } }) => (
                <FormControl size='small' fullWidth={fullWidth} error={!!error}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                inputRef={ref}
                                id={id || name}
                                name={name}
                                checked={Boolean(negativeValue ? !value : value)}
                                size={size}
                                {...rest}
                                onBlur={handleOnBlur}
                                onChange={handleOnChange}
                            />}
                        label={label || ''}
                    />
                    {!!error && <FormHelperText>{error?.message}</FormHelperText>}
                </FormControl>
            )}
        />
    )
}
